export default {
    // could use only this getter and use it for both token and logged
    session: state => state.session,
    // or could have both getters separated
    isLogin: state => state.session.isLogin,
    token: state => state.session.token,
    userInfo: state => state.session.userInfo
}



// WEBPACK FOOTER //
// ./src/store/modules/session/getters.js